import { DocumentNode, gql } from '@apollo/client'

export const GET_PARENT: DocumentNode = gql`
    query GetParent($parent_id: Int) {
        getParent(parent_id: $parent_id) {
            id
            userId
            email
            firstname
            lastname
            phone
            phoneSecond
            address
            city
            zip
            country
            addressSecond
            citySecond
            zipSecond
            countrySecond
            notifAvailabilityMail
            notifAvailabilityPush
            notifReminderMail
            notifReminderPush
            notifBookingMail
            notifBookingPush
            notifEventMail
            notifEventPush
            notifNewPostPush
            notifTaskNote
            notifTaskNotePush
            enrolment
            daycareRegistered
            created
            isNanny
            dataSharingConsent
            daycares {
                daycareId
                daycareName
                daycareCity
                isRpeOrLaep
                childs {
                    childId
                    firstname
                    birthdate
                    preRegistrationBelgium
                    complement
                    request
                    preference {
                        mon
                        tue
                        wed
                        thu
                        fri
                        sat
                        sun
                    }
                }
            }
            childs {
                id
                firstname
                birthdate
                preRegistrationBelgium
                mon
                tue
                wed
                thu
                fri
                sat
                sun
                daycares {
                    daycareId
                    sections {
                        sectionName
                        sectionId
                        isPrimary
                    }
                    group {
                        groupName
                        groupId
                    }
                    complement
                    visible
                }
            }
        }
    }
`

export const UPDATE_PARENT_LINK: DocumentNode = gql`
    mutation UpdateParentLink($daycare_id: Int!, $parent_id: Int!, $child_id: Int!, $request: Boolean) {
        updateParentLink(daycare_id: $daycare_id, parent_id: $parent_id, child_id: $child_id, request: $request)
    }
`

export const GET_PARENT_LIST: DocumentNode = gql`
    query GetParentList($daycare_id: Int) {
        getParentList(daycare_id: $daycare_id) {
            id
            firstname
            lastname
            email
            phone
            phoneSecond
            address
            zip
            city
            country
            addressSecond
            zipSecond
            citySecond
            countrySecond
            firstLogin
            created
            updated
            notifAvailabilityMail
            notifAvailabilityPush
            notifReminderMail
            notifReminderPush
            notifBookingMail
            notifBookingPush
            notifEventMail
            notifEventPush
            notifNewPostPush
            notifTaskNote
            notifTaskNotePush
            enrolment
            daycareRegistered
            isNanny
            daycares {
                daycareId
                daycareName
                daycareCity
                isRpeOrLaep
                childs {
                    childId
                    firstname
                    birthdate
                    preRegistrationBelgium
                    complement
                    request
                    preference {
                        mon
                        tue
                        wed
                        thu
                        fri
                        sat
                        sun
                    }
                }
            }
            childs {
                id
                firstname
                birthdate
                preRegistrationBelgium
                mon
                tue
                wed
                thu
                fri
                sat
                sun
                daycares {
                    daycareId
                    sections {
                        sectionName
                        sectionId
                        isPrimary
                    }
                    group {
                        groupName
                        groupId
                    }
                    complement
                    visible
                }
            }
        }
    }
`

export const GET_CHILD: DocumentNode = gql`
    query GetChild($childId: Int) {
        getChild(childId: $childId) {
            id
            firstname
            birthdate
            preRegistrationBelgium
            created
            daycares {
                daycareId
                daycareName
                daycareCity
                isRpeOrLaep
                sections {
                    sectionName
                    sectionId
                    isPrimary
                }
                group {
                    groupName
                    groupId
                }
                complement
                softwareId
                visible
                parents {
                    parentId
                    firstname
                    lastname
                    email
                    isNanny
                    phone
                    request
                    preference {
                        mon
                        tue
                        wed
                        thu
                        fri
                        sat
                        sun
                    }
                }
            }
        }
    }
`

export const GET_CHILD_LIST: DocumentNode = gql`
    query GetChildList($daycareId: Int) {
        getChildList(daycareId: $daycareId) {
            id
            firstname
            birthdate
            preRegistrationBelgium
            created
            daycares {
                daycareId
                daycareName
                daycareCity
                isRpeOrLaep
                sections {
                    sectionName
                    sectionId
                    isPrimary
                }
                group {
                    groupName
                    groupId
                }
                complement
                softwareId
                visible
                parents {
                    parentId
                    firstname
                    lastname
                    email
                    isNanny
                    phone
                    request
                    preference {
                        mon
                        tue
                        wed
                        thu
                        fri
                        sat
                        sun
                    }
                }
            }
        }
    }
`

export const ATTACH_CHILD_TO_PARENT: DocumentNode = gql`
    mutation AttachChildToParent($parentId: Int!, $childId: Int!, $daycareId: Int!) {
        attachChildToParent(parentId: $parentId, childId: $childId, daycareId: $daycareId)
    }
`

export const MERGE_TWO_CHILDS: DocumentNode = gql`
    mutation MergeTwoChilds($oldChildId: Int!, $newChildId: Int!, $daycareId: Int!) {
        mergeTwoChilds(oldChildId: $oldChildId, newChildId: $newChildId, daycareId: $daycareId)
    }
`
